/* ==========================================================
   MITTI MITRA — Explore Categories Mega Menu JS
   Hover intent, keyboard accessibility & dynamic category swap
   ========================================================== */

(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 749;

  function init(root) {
    var trigger = root.querySelector('[data-capmega-trigger]');
    var panel = root.querySelector('[data-capmega-panel]');
    var overlay = root.querySelector('[data-capmega-overlay]');
    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-capmega-cat]'));
    var subgroups = Array.prototype.slice.call(root.querySelectorAll('[data-capmega-subgroup]'));
    var banners = Array.prototype.slice.call(root.querySelectorAll('[data-capmega-banner]'));
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 220;

    if (!trigger || !panel) return;

    var closeTimer = null;
    var isOpen = false;

    function isMobile() {
      return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
    }

    function clearCloseTimer() {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
    }

    function openPanel() {
      if (isOpen) return;

      clearCloseTimer();
      isOpen = true;
      panel.hidden = false;

      void panel.offsetHeight;

      panel.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');

      if (overlay) {
        overlay.hidden = false;

        void overlay.offsetHeight;

        overlay.setAttribute('data-open', '');
      }

      document.addEventListener('keydown', onKeydown);
    }

    function closePanel() {
      if (!isOpen) return;

      clearCloseTimer();
      isOpen = false;

      panel.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');

      if (overlay) {
        overlay.removeAttribute('data-open');
      }

      document.removeEventListener('keydown', onKeydown);

      window.setTimeout(function () {
        if (isOpen) return;

        panel.hidden = true;

        if (overlay) {
          overlay.hidden = true;
        }
      }, speed);
    }

    function togglePanel() {
      if (isOpen) {
        closePanel();
      } else {
        openPanel();
      }
    }

    function activateCategory(index) {
      var currentIndex = String(index);

      cats.forEach(function (cat) {
        var active = cat.getAttribute('data-cat-index') === currentIndex;

        cat.classList.toggle('is-active', active);
        cat.setAttribute('aria-expanded', String(active));
      });

      subgroups.forEach(function (group) {
        var active = group.getAttribute('data-cat-index') === currentIndex;

        group.hidden = !active;
        group.classList.toggle('is-active', active);
      });

      banners.forEach(function (banner) {
        var active = banner.getAttribute('data-cat-index') === currentIndex;

        banner.hidden = !active;
        banner.classList.toggle('is-active', active);
      });
    }

    function scheduleClose() {
      clearCloseTimer();
      closeTimer = window.setTimeout(closePanel, 200);
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        closePanel();
        trigger.focus();
        return;
      }

      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;

      var currentIndex = cats.findIndex(function (cat) {
        return cat === document.activeElement;
      });

      if (currentIndex === -1) return;

      e.preventDefault();

      var nextIndex = e.key === 'ArrowDown'
        ? Math.min(currentIndex + 1, cats.length - 1)
        : Math.max(currentIndex - 1, 0);

      cats[nextIndex].focus();
    }

    root.addEventListener('mouseenter', function () {
      if (isMobile()) return;
      openPanel();
    });

    root.addEventListener('mouseleave', function () {
      if (isMobile()) return;
      scheduleClose();
    });

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      togglePanel();
    });

    cats.forEach(function (cat) {
      var index = cat.getAttribute('data-cat-index');

      cat.addEventListener('mouseenter', function () {
        if (!isMobile()) {
          activateCategory(index);
        }
      });

      cat.addEventListener('focus', function () {
        activateCategory(index);
      });
    });

    document.addEventListener('click', function (e) {
      if (!isOpen || root.contains(e.target)) return;
      closePanel();
    });

    if (overlay) {
      overlay.addEventListener('click', closePanel);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-capmega]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var newRoot = e.target.querySelector('[data-capmega]');

    if (newRoot) {
      init(newRoot);
    }
  });
})();